/**
 * sockjs-client (STOMP) loads browser-crypto.js, which uses Node's `global`.
 * Browser/Webpack 5 bundles often omit `global` → ReferenceError.
 * Must run before the main bundle (same polyfills chunk as zone.js).
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const g = window as any;
if (typeof g.global === 'undefined') {
    g.global = typeof globalThis !== 'undefined' ? globalThis : window;
}
